import React from "react";

interface AnalyticsWrapperProps {
  showAnalytics: boolean;
  children: React.ReactNode;
}

const AnalyticsWrapper: React.FC<AnalyticsWrapperProps> = ({
  showAnalytics,
  children,
}) => {
  return (
    <div
      className={`space-y-6 transition-all duration-300 ease-in-out overflow-hidden ${
        showAnalytics
          ? "max-h-[1000px] opacity-100 mb-6"
          : "max-h-0 opacity-0 mb-0"
      }`}
    >
      {children}
    </div>
  );
};

export default AnalyticsWrapper;
